import request from '@/utils/request'  // 添加了token
import request2 from '@/utils/request2'  // 无token

// 获取报名验证码
export function RequestPhoneCode (data) {
    return request2({
        url: '/yijiajiaUserInfo/RequestPhoneCode',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 报名接口
export function signUp (data) {
    return request2({
        url: '/yijiajiaUserInfo/signUp',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 获取登录验证码
export function RequestPhoneLoginCode (data) {
    return request2({
        url: '/yijiajiaUserInfo/RequestPhoneLoginCode',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 登录接口
export function phoneCodeLogin (data) {
    return request2({
        url: '/yijiajiaUserInfo/phoneCodeLogin',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 获取用户参赛证
export function getUserMatchCertInfo (data) {
    return request({
        url: '/yijiajiaUserInfo/getUserMatchCertInfo',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 获取我的团队
export function getMyTeamInfo (data) {
    return request({
        url: '/yijiajiaUserInfo/getMyTeamInfo',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 再次邀约
export function reInvitation (data) {
    return request({
        url: '/yijiajiaUserInfo/reInvitation',
        method: 'post',
        data: {
            ...data
        }
    })
}
// 新增邀约
export function newlyInvitation (data) {
    return request({
        url: '/yijiajiaUserInfo/newlyInvitation',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 接受邀约 / 拒绝邀约
export function agreeOrRefuse (data) {
    return request2({
        url: '/yijiajiaUserInfo/agreeOrRefuse',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 个人信息
export function getUserInfo (data) {
    return request({
        url: '/yijiajiaUserInfo/getUserInfo',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 补充个人信息
export function supplyUserInfo (data) {
    return request({
        url: '/yijiajiaUserInfo/supplyUserInfo',
        method: 'post',
        data: {
            ...data
        }
    })
}

// 我的成绩
export function myGrades (data) {
    return request({
        url: '/yijiajiaUserInfo/myGrades',
        method: 'post',
        data: {
            ...data
        }
    })
}


// 报名通道验证
export function checkSignUpPassageway (data) {
    return request2({
        url: '/yijiajiaUserInfo/checkSignUpPassageway',
        method: 'post',
        data: {
            ...data
        }
    })
}









